import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { func, string, shape, node } from 'prop-types';

import { createApplication, updateApplication } from 'modules/application';
import { showNotification } from 'modules/snackbar';
import { PropTypes } from 'helpers/react';
const { wizardConfigShape } = PropTypes;
import { handleGraphQLSubmissionFailure } from 'helpers/redux/form';

import popoverDialogWizardContainer from 'shared-components/Wizard/PopoverDialogWizardContainer';
import Wizard from 'shared-components/Wizard';
import wizardConfig from '../wizard-config';

@connect(
  (state, ownProps) => ({
    initialValues: ownProps.application
  }),
  {
    push,
    showNotification,
    createApplication,
    updateApplication
  }
)
export default class ApplicationWizardContainer extends React.Component {
  static propTypes = {
    application: shape({
      id: string,
      name: string,
      description: string,
      iconUrl: string
    }),
    initialValues: shape({
      id: string,
      name: string,
      description: string,
      url: string,
      iconUrl: string,
      oauth2RedirectUrls: string
    }),
    wizardConfig: wizardConfigShape.isRequired,
    baseRoutePath: string.isRequired,
    onClose: func.isRequired,
    createApplication: func.isRequired,
    updateApplication: func.isRequired,
    showNotification: func.isRequired,
    push: func.isRequired,
    children: node
  };

  static defaultProps = {
    wizardConfig,
    baseRoutePath: '/applications/overview/new/'
  };

  handleSubmit = values => {
    const submitHandler = this.props.application
      ? this.props.updateApplication
      : this.props.createApplication;

    return submitHandler(values)
      .then(this.handleSubmissionSuccess)
      .catch(handleGraphQLSubmissionFailure);
  };

  handleSubmissionSuccess = response => {
    let applicationId;
    let message;

    if (this.props.application) {
      applicationId = get(this.props, 'application.id');
      message = 'Application updated successfully!';
    } else {
      applicationId = get(response, 'data.createApplication.id');
      message = 'Application created successfully!';
    }

    this.props.showNotification(message);
    this.props.push(`/applications/${applicationId}`);
  };

  render() {
    return (
      <Wizard
        formName="application-wizard"
        config={this.props.wizardConfig}
        currentPageNode={this.props.children}
        baseRoutePath={this.props.baseRoutePath}
        onClose={this.props.onClose}
        onSubmit={this.handleSubmit}
        hideStepper
        initialValues={this.props.initialValues}
        submitButtonText={this.props.application ? 'Save' : 'Create'}
      >
        {popoverDialogWizardContainer({
          title: get(this.props, 'application.name') || 'New Application'
        })}
      </Wizard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/pages/application-wizard/components/ApplicationWizardContainer.js